/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangePatientLocationAliases {
  AUTOCOMPLETE_DEPARTMENTS = 'autocomplete-departments',
  BARCODE_COMPONENT_LOCAL_PA = 'barcode-component-local-pa',
  BARCODE_FIELD = 'barcode-field',
  CANCELAR_BUTTON = 'cancelar-button',
  CONTEXTUAL_BAR_TROCA_LOCAL_INF = 'contextual-bar-troca-local-inf',
  FETCH_DEPARTMENTS = 'fetch-departments',
  FIELD_DEPARTMENTS = 'field-departments',
  GLOBAL_ACTIONS_TROCA = 'global-actions-troca',
  LAYOUT_TROCA_LOCAL_INFO = 'layout-troca-local-info',
  MAPPER_DEPARTMENTS = 'mapper-departments',
  PANEL_BUTTONS = 'panel-buttons',
  PANEL_DEPARTMENTS = 'panel-departments',
  TEXT_DEPARTMENTS = 'text-departments',
}
export { ChangePatientLocationAliases };
